/**
 * Plan 07-05 / PERF-02 — fires once when BoardingOverlay renders its
 * interactive Board button. The Playwright `perf-boarding-ready.spec.ts`
 * probe asserts the mark lands within 5000ms of navigation.
 *
 * Idempotent — repeated calls are no-ops (some React 19 renders can double-
 * invoke effects under strict mode; we don't want multiple marks).
 *
 * Never throws: the performance API might be unavailable in niche browsers,
 * or `measure()` might reject the named start mark — either case is silently
 * swallowed. The Playwright probe treats absence of the mark as its own
 * failure signal, so silent no-op here is the right behavior.
 */
let fired = false;

export function markBoardingReady(): void {
  if (fired) return;
  fired = true;
  try {
    performance.mark('boarding-ready');
    // `performance.measure` from navigation start to the named mark. Modern
    // browsers default the start argument to navigationStart automatically
    // when the argument is omitted.
    performance.measure('boot-to-boarding', undefined, 'boarding-ready');
  } catch {
    // performance.mark/measure can throw in rare environments — fail silent.
  }
}

/**
 * Test-only reset. Not exported publicly; internal helper for vitest suites
 * that want to exercise the fire-once contract across multiple mounts.
 */
export function __resetBoardingReadyForTests(): void {
  fired = false;
}
